import { Link } from "react-router-dom";
import { ORDERS_VIEW_ROUTER_URL } from "@Router/routerPath";

/**
 * 三聯發票折讓總覽列操作選單（搭配 filterMenu 使用）
 *
 * @param {object} rowData
 * @param {number} rowData.orderID
 * @param {boolean} rowData.isUploadedCertificate
 * @param {object} [extend]
 * @param {Function} [extend.openReviewCertificate]
 */
export const getTriplicateAllowanceMenuMap = (rowData, extend) => {
	const { orderID, isUploadedCertificate } = rowData || {};
	const { openReviewCertificate } = extend || {};

	return [
		{
			text: "查看",
			condition: !!orderID,
			component: Link,
			to: ORDERS_VIEW_ROUTER_URL(orderID),
		},
		{
			text: "查看折讓證明單",
			condition: isUploadedCertificate === true,
			// 由頁面 openReviewCertificate 封裝 dialog 開啟與 confirmPath 檢查
			onClick: () => openReviewCertificate?.(rowData),
		},
	];
};
